import { defineMessages } from 'react-intl';

const messages = defineMessages({
  no: {
    id: 'questionnaireSubmissionForm.no',
    defaultMessage: 'No',
  },
  numberTooLarge: {
    id: 'questionnaireSubmissionForm.numberTooLarge',
    defaultMessage: 'Value must be at most {max}.',
  },
  numberTooSmall: {
    id: 'questionnaireSubmissionForm.numberTooSmall',
    defaultMessage: 'Value must be at least {min}.',
  },
  questionLabel: {
    id: 'questionnaireSubmissionForm.questionLabel',
    defaultMessage: 'Q{number}',
  },
  scaleRange: {
    id: 'questionnaireSubmissionForm.scaleRange',
    defaultMessage: '({min}-{max})',
  },
  submitError: {
    id: 'questionnaireSubmissionForm.submitError',
    defaultMessage: "We couldn't submit your answers. Please try again.",
  },
  yes: {
    id: 'questionnaireSubmissionForm.yes',
    defaultMessage: 'Yes',
  },
});

export default messages;
